import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Col,
  Container,
  Row,
  Card,
  CardBody,
  // Form,
  Table,
  // Input,
  Button,
  // InputGroup,
  Modal,
  // Dropdown,
  // DropdownMenu,
  // DropdownToggle,
  // DropdownItem,
} from "reactstrap"
import SweetAlert from "react-bootstrap-sweetalert";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter, Link, useHistory } from "react-router-dom";
//Import Breadcrumb
import Loader from "../../components/Common/Loader"
import Pagination from "../../components/Common/Pagination"
import Select from "react-select";
import { campaignList, campaignFilter, campaignDelete } from "../../store/campaign/actions"
import { getContactsOfCampaign, getContactsWitUser, getEncargadosOfCampaign, getSupervisor, postContactsOfCampaign, postEncargadoOfCampaign, postRemoveContactsOfCampaign, postRemoveEncargadosOfCampaign } from "../../helpers/backend";

import { useSortableData } from "../../hooks/useSortableData";
import TableCustom from "../../components/Common/Table";
import ButtonVolver from "../../components/ButtonVolver";


const Campaign = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"))
  const groups = String(user.groups);
  // const [search, setSearch] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [modalEncargadoOpen, setModalEncargadoOpen] = useState(false);
  const [idCampaign, setIdCampaign] = useState(null);
  const [selectedContact, setSelectedContact] = useState(null);
  // const [dropdownOpen, setDropdownOpen] = useState(false);
  const [confirmText, setConfirmText] = useState(false);
  const [confirmDel, setConfirmDel] = useState("");
  const [alert, setAlert] = useState(false);
  const [contactsList, setContactsList] = useState({});
  const getContactsData = async () => {
    const response = await getContactsOfCampaign(idCampaign);
    const data = response.data;
    setContactsList(data);
  };
  const [encargadosList, setEncargadosList] = useState({});
  const getEncargadosData = async () => {
    const response = await getEncargadosOfCampaign(idCampaign);
    const data = response.data;
    setEncargadosList(data);
  };
  const [contacts, setContacts] = useState({});
  const getContactData = async () => {
    const response = await getContactsWitUser();
    const data = response.data;
    setContacts(data)
  }
  const [supervisor, setSupervisor] = useState({});
  const getSupervisorData = async () => {
    const response = await getSupervisor();
    const data = response.data;
    setSupervisor(data)
  }

    const theme = useSelector((state) => state.theme.theme) || 'light'
  

  // const onChange = (e) => {
  //   setSearch(e.target.value);
  // };

  // const onSubmit = (e) => {
  //   e.preventDefault();
  //   dispatch(campaignFilter(`?search=${search}`));
  // };

  // const resetSearch = () => {
  //   dispatch(campaignFilter(`?search=`));
  //   setSearch("");
  // };

  // const toggleDropdown = (idx) => {
  //   setDropdownOpen(!dropdownOpen);

  // }
  useEffect(() => {
    dispatch(campaignList())
    getContactData()
    getSupervisorData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  useEffect(() => {
    if (idCampaign) {
      getContactsData()
      getEncargadosData()
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idCampaign])

  const params = {
    count: props.campaign.count,
    next: props.campaign.next,
    previous: props.campaign.previous,
    results: props.campaign.results,
  };

  const formattedData = Array.isArray(params.results)
    ? params.results.map((campaign) => ({
        ...campaign,
        encargado: campaign.encargado?.length > 0 ? campaign.encargado[0] : "",
        ver: (
          <div>
            <Button
              className="btn-sm"
              color="success"
              onClick={() => {
                setIdCampaign(campaign.id);
                setModalOpen(true);
              }}
            >
              Usuarios
            </Button>
            {groups.includes("SuperAdmin") ||
            groups.includes("Administrador") ? (
              <>
                <Button
                  className="btn-sm ms-1"
                  color="warning"
                  onClick={() => {
                    setIdCampaign(campaign.id);
                    setModalEncargadoOpen(true);
                  }}
                >
                  Encargados
                </Button>
              </>
            ) : null}
          </div>
        ),
        acciones: (
          <div>
            <Link to={`/campaign/update/${campaign.id}`}>
              <span className="bx bx-edit fa-lg align-middle"></span>
            </Link>{" "}
            <Link to="#" onClick={() => handleConfirm(campaign.id)}>
              <span className="fa fa-trash fa-md align-middle"></span>
            </Link>
            <Link to={`/campaign/availability/${campaign.id}`}>
              <span className="fa fa-calendar-alt mx-2 align-middle"></span>
            </Link>
          </div>
        ),
      }))
    : [];

    const columns = [
      { key: "name", label: "Nombre", filterable: true },
      { key: "description", label: "Descripción", filterable: true },
      { key: "encargado", label: "Encargados", filterable: true },
      { key: "ver", label: "Ver", filterable: false },
      {
        key: "acciones",
        label: "Acción",
        filterable: false,
      },
    ];

  const assignContacts = async () => {
    const response = await postContactsOfCampaign(idCampaign, {
      contact: selectedContact
    })
    console.log(response);
    if (response.status === 200) {
      getContactsData()
      dispatch(campaignList())
    }
  }
  const assignEncargado = async () => {
    const response = await postEncargadoOfCampaign(idCampaign, {
      contact: selectedContact
    })
    console.log(response);
    if (response.status === 200) {
      getEncargadosData()
      dispatch(campaignList())
    }
  }
  const removeContacts = async (id) => {
    const response = await postRemoveContactsOfCampaign(idCampaign, {
      contact: [id]
    })
    console.log(response);
    if (response.status === 200) {
      getContactsData()
      dispatch(campaignList())
    }
  }
  const removeEncargado = async (id) => {
    const response = await postRemoveEncargadosOfCampaign(idCampaign, {
      contact: [id]
    })
    console.log(response);
    if (response.status === 200) {
      getEncargadosData()
      dispatch(campaignList())
    }
  }
  const handleConfirm = (id) => {
    setConfirmText(true)
    setConfirmDel(id)
  }
  console.log(params)

  // Para el hook de ordenamiento, usamos los resultados obtenidos
    const {  requestSort, sortConfig } = useSortableData(
      params.results,
      { key: "", direction: "asc" }
    );
  
    // Función para mostrar el icono de ordenación en cada columna
    const getSortIcon = (columnName) => {
      if (sortConfig?.key === columnName) {
        return sortConfig.direction === "asc" ? <span><i className="fa fa-sort-up" /></span> : <span><i className="fa fa-sort-down" /></span>;
      }
      return null;
    };


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title> Cuidad Limpia | Campañas </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Col className="d-flex gap-3 mb-4 align-items-center">
            <ButtonVolver />
            <span style={{ fontSize: "1.2rem", fontWeight: "600" }}>
              Campañas
            </span>
          </Col>
          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Modal
                isOpen={modalOpen}
                toggle={() => setModalOpen(false)}
                centered={true}
                size="lg"
              >
                <div className="modal-header">
                  <h3 className="mt-2">Usuarios</h3>
                  <button
                    type="button"
                    onClick={() => setModalOpen(false)}
                    className="btn-close btn-sm"
                    data-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <h6 className="p-2 text-dark">
                  Agrega un usuario a la Campaña
                </h6>
                <div className="px-3">
                  <Row className="d-flex justify-content-center">
                    <Row className="mb-2">
                      <Col lg={10} className="mt-1">
                        <Select
                          options={
                            Array.isArray(contacts)
                              ? contacts.map((item) => ({
                                  label: item.get_full_name,
                                  value: item.id,
                                }))
                              : []
                          }
                          onChange={(selectedOptions) => {
                            const selectedContactData = selectedOptions.map(
                              (option) => option.value
                            );
                            setSelectedContact(selectedContactData);
                          }}
                          placeholder={"Seleccione"}
                          isMulti={true}
                          menuPosition="fixed"
                          styles={{
                            control: (base) => ({
                              ...base,
                              backgroundColor:
                                theme === "dark" ? "#242424" : "#fff",
                              color: theme === "dark" ? "#c3cbe4" : "#000",
                              borderColor:
                                theme === "dark" ? "#3b3b3b" : "#d2d2d2",
                              cursor: "pointer",
                              fontSize: "0.9rem",
                            }),
                            menu: (base) => ({
                              ...base,
                              backgroundColor:
                                theme === "dark" ? "#242424" : "#fff",
                              borderRadius: "8px",
                              boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                            }),
                            option: (base, { isFocused, isSelected }) => ({
                              ...base,
                              backgroundColor: isSelected
                                ? theme === "dark"
                                  ? "#242424"
                                  : "#ccc"
                                : isFocused
                                ? theme === "dark"
                                  ? "#121212"
                                  : "#ddd"
                                : "transparent",
                              color: theme === "dark" ? "#c3cbe4" : "#000",
                              padding: "10px",
                              fontSize: "0.9rem",
                              cursor: "pointer",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              color: theme === "dark" ? "#c3cbe4" : "#000",
                            }),
                          }}
                        />
                      </Col>
                      <Col lg={2}>
                        <Link
                          to="#"
                          onClick={() => {
                            assignContacts();
                          }}
                        >
                          <span className="font-size-16">
                            <i className=" bx bx-lg bx-plus-circle "></i>
                          </span>
                        </Link>
                      </Col>
                    </Row>
                    <Table
                      responsive
                      hover
                      className={`font-size-13 text-center ${
                        theme === "dark" ? "table-dark" : "table-light"
                      }`}
                    >
                      <thead>
                        <tr>
                          <th style={{ color: theme === "dark" && "#c3cbe4" }}>
                            #
                          </th>
                          <th
                            onClick={() => requestSort("get_full_name", "text")}
                            style={{ color: theme === "dark" && "#c3cbe4" }}
                          >
                            {getSortIcon("get_full_name")} Nombre
                          </th>
                          <th style={{ color: theme === "dark" && "#c3cbe4" }}>
                            Telefono
                          </th>
                          <th style={{ color: theme === "dark" && "#c3cbe4" }}>
                            Eliminar
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        className={` ${theme === "dark" ? "" : "table-light"}`}
                      >
                        {Array.isArray(contactsList)
                          ? contactsList.map((item, idx) => (
                              <tr key={idx}>
                                <th
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                    height: "60px",
                                  }}
                                >
                                  {idx + 1}
                                </th>
                                <td
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                  }}
                                >
                                  {item.get_full_name}
                                </td>
                                <td
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                  }}
                                >
                                  {item.description}
                                </td>
                                <td
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                  }}
                                >
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => removeContacts(item.id)}
                                  >
                                    <i className="fas fa-times"></i>
                                  </span>
                                </td>
                              </tr>
                            ))
                          : []}
                      </tbody>
                    </Table>
                  </Row>
                </div>
                <Row className="mt-3 p-2">
                  <Col className="d-flex justify-content-end">
                    <button
                      className=" btn btn-primary"
                      onClick={() => setModalOpen(false)}
                    >
                      Cerrar
                    </button>
                  </Col>
                </Row>
              </Modal>
              <Modal
                isOpen={modalEncargadoOpen}
                toggle={() => setModalEncargadoOpen(false)}
                centered={true}
                size="lg"
              >
                <div className="modal-header">
                  <h3 className="mt-2">Encargados</h3>
                  <button
                    type="button"
                    onClick={() => setModalEncargadoOpen(false)}
                    className="btn-close btn-sm"
                    data-dismiss="modal"
                    aria-label="Close"
                  ></button>
                </div>
                <h6 className="p-2 text-dark mx-4">
                  Agrega un Encargado agregado la Campaña
                </h6>
                <div className="px-3">
                  <Row className="d-flex justify-content-center">
                    <Row className="mb-2">
                      <Col lg={10} className="mt-1">
                        <Select
                          id="supervisor"
                          name="supervisor"
                          options={
                            Array.isArray(supervisor)
                              ? supervisor.map((item) => ({
                                  label: item.get_full_name,
                                  value: item.id,
                                }))
                              : []
                          }
                          onChange={(selectedOptions) => {
                            const selectedContactData = selectedOptions.map(
                              (option) => option.value
                            );
                            setSelectedContact(selectedContactData);
                          }}
                          placeholder={"Seleccione"}
                          isMulti={true}
                          menuPosition="fixed"
                          styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor:
                              theme === "dark" ? "#242424" : "#fff",
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                            borderColor:
                              theme === "dark" ? "#3b3b3b" : "#d2d2d2",
                            cursor: "pointer",
                            fontSize: "0.9rem",
                          }),
                          menu: (base) => ({
                            ...base,
                            backgroundColor:
                              theme === "dark" ? "#242424" : "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                          }),
                          option: (base, { isFocused, isSelected }) => ({
                            ...base,
                            backgroundColor: isSelected
                              ? theme === "dark"
                                ? "#242424"
                                : "#ccc"
                              : isFocused
                              ? theme === "dark"
                                ? "#121212"
                                : "#ddd"
                              : "transparent",
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                            padding: "10px",
                            fontSize: "0.9rem",
                            cursor: "pointer",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                          }),
                        }}
                        />
                      </Col>
                      <Col lg={2}>
                        <Link
                          to="#"
                          onClick={() => {
                            assignEncargado();
                          }}
                        >
                          <span className="font-size-16">
                            <i className=" bx bx-lg bx-plus-circle "></i>
                          </span>
                        </Link>
                      </Col>
                    </Row>
                    <Table
                      responsive
                      hover
                      className={`font-size-13 text-center ${
                        theme === "dark" ? "table-dark" : "table-light"
                      }`}
                    >
                      <thead>
                        <tr>
                          <th style={{ color: theme === "dark" && "#c3cbe4" }}>
                            #
                          </th>
                          <th style={{ color: theme === "dark" && "#c3cbe4" }}>
                            Nombre
                          </th>
                          <th style={{ color: theme === "dark" && "#c3cbe4" }}>
                            Eliminar
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        className={` ${theme === "dark" ? "" : "table-light"}`}
                      >
                        {Array.isArray(encargadosList)
                          ? encargadosList.map((item, idx) => (
                              <tr key={idx}>
                                <th
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                    height: "60px",
                                  }}
                                >
                                  {idx + 1}
                                </th>
                                <td
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                  }}
                                >
                                  {item.get_full_name}
                                </td>
                                <td
                                  style={{
                                    backgroundColor:
                                      theme === "dark" ? "#242424" : "#fff",
                                  }}
                                >
                                  <span
                                    style={{ cursor: "pointer" }}
                                    onClick={() => removeEncargado(item.id)}
                                  >
                                    <i className="fas fa-times"></i>
                                  </span>
                                </td>
                              </tr>
                            ))
                          : []}
                      </tbody>
                    </Table>
                  </Row>
                </div>
                <Row className="mt-3 p-2">
                  <Col className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => setModalEncargadoOpen(false)}
                    >
                      Cerrar
                    </button>
                  </Col>
                </Row>
              </Modal>
              {confirmText ? (
                <SweetAlert
                  title="¿Estás seguro de que quieres eliminar esta Campaña ?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  confirmBtnText="Si"
                  cancelBtnBsStyle="danger"
                  cancelBtnText="No"
                  onConfirm={() => {
                    dispatch(campaignDelete(confirmDel));
                    setConfirmText(false);
                    setAlert(true);
                  }}
                  onCancel={() => {
                    setConfirmText(false);
                  }}
                ></SweetAlert>
              ) : null}
              {alert ? (
                <SweetAlert
                  title="Hecho!"
                  success
                  timeout={2000}
                  showConfirm={false}
                  onConfirm={() => {
                    setConfirmText(false);
                    dispatch(campaignList());
                    setAlert(false);
                  }}
                >
                  Se ha eliminado la Campaña
                </SweetAlert>
              ) : null}
              <Card
                className="col-lg-11 mx-auto "
                style={{ backgroundColor: "transparent", border: "none" }}
              >
                <Row>
                  <Col style={{ display: "flex", alignItems: "center" }}>
                    <h2 className="font-size-18">Lista de Campañas</h2>
                  </Col>

                  <Col
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: ".5rem",
                      justifyContent: "end",
                    }}
                  >
                    <Link
                      className="btn btn-primary font-size-15 waves-effect waves-light"
                      to="/campaign/create"
                    >
                      Agregar
                    </Link>
                    <div style={{ maxWidth: "200px" }}>
                      <Select
                        id="tipificaciones"
                        name="tipificaciones"
                        options={[
                          { label: "Tipo", value: "/tipoGestionContacto" },
                          {
                            label: "Resultado",
                            value: "/calificacionContacto",
                          },
                          {
                            label: "Calificación",
                            value: "/descripcionCalificacion",
                          },
                        ]}
                        onChange={(selectedOption) => {
                          history.push(selectedOption.value);
                        }}
                        placeholder="Tipificaciones"
                        isMulti={false}
                        menuPosition="fixed"
                        styles={{
                          control: (base) => ({
                            ...base,
                            backgroundColor:
                            theme === "dark" ? "#242424" : "#fff",
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                            borderColor:
                            theme === "dark" ? "#3b3b3b" : "#d2d2d2",
                            cursor: "pointer",
                            minWidth: "150px",
                            fontSize: ".95rem",
                            margin: "0 8px", // Similar al className="d-inline mx-2"
                          }),
                          menu: (base) => ({
                            ...base,
                            backgroundColor:
                              theme === "dark" ? "#242424" : "#fff",
                            borderRadius: "8px",
                            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
                          }),
                          option: (base, { isFocused, isSelected }) => ({
                            ...base,
                            backgroundColor: isSelected
                              ? theme === "dark"
                                ? "#242424"
                                : "#ccc"
                              : isFocused
                              ? theme === "dark"
                                ? "#121212"
                                : "#ddd"
                              : "transparent",
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                            padding: "10px",
                            fontSize: "0.9rem",
                            cursor: "pointer",
                          }),
                          singleValue: (base) => ({
                            ...base,
                            color: theme === "dark" ? "#c3cbe4" : "#000",
                          }),
                        }}
                        
                      />
                    </div>
                  </Col>
                </Row>
              </Card>

              <Card style={{ backgroundColor: "transparent", border: "none" }}>
                {params.results ? (
                  <>
                    <div className="table-responsive">
                      <TableCustom
                        data={formattedData || []}
                        columns={columns}
                        theme={theme}
                      />
                    </div>
                    <div style={{ padding: "1rem" }}>
                      <Pagination
                        count={params.count}
                        next={params.next}
                        previous={params.previous}
                        limit={30}
                        baseUrl="campaign/campaign/"
                        filterFunction={campaignFilter}
                      />
                    </div>
                  </>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
}


const mapStateToProps = (state) => {
  const { error, loading, campaign, campaignDeleted } = state.Campaign;
  return { error, loading, campaign, campaignDeleted };
};

export default withRouter(connect(mapStateToProps)(Campaign));
